import React from "react";
import { PropTypes } from "prop-types";

const Button = ({
  text,
  color,
  onClick,
  formdisable,
  disabled,
  img,
  width,
  height,
  word,
  testId,
}) => {
  return (
    <button
      data-testid={testId}
      disabled={disabled || formdisable}
      onClick={onClick}
      style={{ color: `${color}`, height: `${height}`, width: `${width}` }}
      className="button"
      type="submit"
    >
      <span>{text}</span>
      {word}
      <div>{img}</div>
    </button>
  );
};

Button.propTypes = {
  color: PropTypes.any,
  disabled: PropTypes.any,
  formdisable: PropTypes.any,
  height: PropTypes.any,
  img: PropTypes.any,
  onClick: PropTypes.any,
  testId: PropTypes.any,
  text: PropTypes.any,
  width: PropTypes.any,
  word: PropTypes.any
}

export default Button;
